// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"r7-z"};